import { IApiError } from '@/models/apiError.model';
import { IConversation } from '@/models/conversation.model';
import { IPagination } from '@/models/pagination.model';

export const SLICE_NAME = 'conversations';

export interface ConversationsState {
  conversations: IConversation[] | null;
  isLoading: boolean;
  error: IApiError | null;
  pagination: IPagination | null;
}

export const initialState: ConversationsState = {
  conversations: null,
  pagination: null,
  isLoading: false,
  error: null,
};
